import React from "react";
import { Link, Route, Switch } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { LanguageSelector, Namespaces } from "../components/LanguageSelector";
import "./Header.css";

export default function Header({ returnTo, roller }) {
  const { t } = useTranslation();
  const photo = (roller && roller.photoUrl) || "/logo.jpg";

  return (
    <nav className="navbar navbar-light shadow-sm bg-white">
      <div className="navbar__header">
        <Switch>
          <Route exact path={["/awards/*", "/me"]}>
            <Link
              to={returnTo}
              className="navbar__return-btn align-middle text-center"
            >
              <span className="material-icons ">arrow_back</span>
            </Link>
          </Route>
          <Route>
            <img
              src="/logo.jpg"
              width="40"
              height="40"
              className="d-inline-block rounded-circle align-middle"
              alt=""
              loading="lazy"
            />
          </Route>
        </Switch>
        {/* <a href="/"> */}
        <span className="h3 ml-3 mb-0 align-middle font-weight-bold">
          Pro Broller
        </span>
        {/* </a> */}
      </div>


      <div className="navbar__userItemsWrapper">
        <Switch>
          <Route exact path={["/me", "/login", "/admin"]}>
            {null}
          </Route>
          <Route>
            {photo ? (
              <div>
                <Link className="btn btn-link text-primary" to="/me">
                  {t(`${Namespaces.profile}.profile`)}
                </Link>
                <Link to="/me">
                  <img
                    src={photo}
                    width="40"
                    height="40"
                    className="navbar__profile-image d-inline-block rounded-circle align-middle shadow-sm"
                    alt=""
                    loading="lazy"
                  />
                </Link>
              </div>
            ) : null}
          </Route>
        </Switch>
        <LanguageSelector />
      </div>
    </nav>
  );
}
